import CachedResourceStore from '@/store/modules/CachedResourceStore'
import { SystemMessage } from '@/models/SystemMessage'

export default new CachedResourceStore<SystemMessage>(SystemMessage, {
	namespaced: true
})
